import SmallHeading from './../components/SmallHeading';
import PostCard from './../components/PostCard';

function Posts() {
  return (
    <section className="bg-emerald-50 md:shadow-md mx-auto py-2 my-2 md:py-10 md:my-10 rounded-xl">
      <SmallHeading name="Related Posts" tstyle="text-gray-600 text-xl ml-10" />
      
      <div className="grid grid-cols-1 gap-6 mt-10 mx-10">
        <PostCard 
          heading="The Importance of Compliance in Growing Businesses"  
          link="/blogs/1"
        />
        <PostCard 
          heading="How to Protect Your Intellectual Property"
          link="/blogs/2"
        />
        <PostCard 
          heading="Legal Tech: AI-Driven Solutions in Law"
          link="/blogs/3"
        />

      </div>
    </section>
  );
}

export default Posts;
